import { useLayoutEffect, useState } from 'react';
/** The disclosure owns its open state. Floating help yields while a person
 * reviews verification, just as the extension already yields to compare
 * details. Observe the actual document/shadow root, including removal on
 * navigation, so help returns without acknowledging its invitation. */
export function useVerificationDisclosureOpen(anchor) {
    const [open, setOpen] = useState(false);
    useLayoutEffect(() => {
        const root = anchor.current?.getRootNode();
        if (!root?.querySelector)
            return;
        let previous = Boolean(root.querySelector('.oq-verification-section[open]'));
        setOpen(previous);
        const update = () => {
            const next = Boolean(root.querySelector('.oq-verification-section[open]'));
            if (previous !== next) {
                previous = next;
                setOpen(next);
            }
        };
        const observer = new MutationObserver(update);
        observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
        return () => observer.disconnect();
    }, [anchor]);
    return open;
}
//# sourceMappingURL=useVerificationDisclosureOpen.js.map